<template>
  <QueSomos />
</template>

<script>
import QueSomos from "@/components/quemSomos/queSomos.vue";

export default {
  name: "PageQuemSomos",
  components: {
    QueSomos
  }
};
</script>